import { call, put, takeEvery } from 'redux-saga/effects';
import { businessEntityActionCreators, BusinessEntityActionKeys, UpdateBeProductCategories } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateBeProductCategories } from '../businessEntityApi';

function* updateBeProductCategoriesSaga(action: UpdateBeProductCategories) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<{
    businessEntityId: number;
    productCategoryIds: number[];
  }> = yield call(updateBeProductCategories, {
    beId: action.payload.beId,
    productCategoryIds: action.payload.categoryIds
  });

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(
      businessEntityActionCreators.setProductCategories({
        beId: response.value.businessEntityId,
        categoryIds: response.value.productCategoryIds
      })
    );
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateBeProductCategories() {
  yield takeEvery(BusinessEntityActionKeys.UPDATE_BE_PRODUCT_CATEGORIES, updateBeProductCategoriesSaga);
}
